import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next"; // I18N
import "./BankStepsModal.css";

const BankStepsModal = ({ show, onHide, selectedBank, amount }) => {
  const { t } = useTranslation(); // I18N
  const [currentStep, setCurrentStep] = useState(1);

  if (!show) return null;

  const imageMap = {
    "Dahabshiil Bank": "dh.png",
    "Dara Salaam Bank": "ds.png",
    "Salaam Bank": "sb.png",
    "Salaam Somali Bank": "ssb.png",
  };

  const getBankImage = () => {
    return imageMap[selectedBank?.display] || "dh.png";
  };

  const nextStep = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const renderStep1 = () => (
    <>
      <h5 className="step-header">{t('donate.bankSteps.step1Title')}</h5>
      <h4 className="step-content">
        <span className="required-star">* </span>
        {t('donate.bankSteps.step1Body')}{" "}
        <span className="highlight">
          {selectedBank?.display === "Dahabshiil Bank"
            ? selectedBank?.maskedAccount
            : selectedBank?.accNo}
        </span>{" "}
        {t('donate.bankSteps.step1And')} <span className="highlight">${amount}</span> {t('donate.bankSteps.step1Dollar')}
      </h4>
      <div className="step-image-container">
        <img
          src={require(`../../images/${getBankImage()}`)}
          alt="Bank"
          className="step-image"
        />
      </div>
      <div className="step-buttons">
        <button className="step-btn next-btn" onClick={nextStep}>
          {t('donate.bankSteps.next')}
        </button>
      </div>
    </>
  );

  const renderStep2 = () => (
    <>
      <h5 className="step-header">{t('donate.bankSteps.step2Title')}</h5>
      <h4 className="step-content">
        <span className="required-star">* </span>
        {t('donate.bankSteps.step2Body')}
      </h4>
      <div className="step-image-container">
        <img
          src={require("../../images/step2.png")}
          alt="Step 2"
          className="step-image"
        />
      </div>
      <div className="step-buttons">
        <button className="step-btn back-btn" onClick={prevStep}>
          {t('donate.bankSteps.back')}
        </button>
        <button className="step-btn next-btn" onClick={nextStep}>
          {t('donate.bankSteps.next')}
        </button>
      </div>
    </>
  );

  const renderStep3 = () => (
    <>
      <h5 className="step-header">{t('donate.bankSteps.step3Title')}</h5>
      <h4 className="step-content">
        <span className="required-star">* </span>
        {t('donate.bankSteps.step3Body')}{" "}
        <span className="bold">{t('donate.bankSteps.pin')}</span>
      </h4>
      <div className="step-image-container">
        <img
          src={require("../../images/step3.png")}
          alt="Step 3"
          className="step-image"
        />
      </div>
      <div className="step-buttons">
        <button className="step-btn back-btn" onClick={prevStep}>
          {t('donate.bankSteps.back')}
        </button>
        <button className="step-btn done-btn" onClick={onHide}>
          {t('donate.bankSteps.done')}
        </button>
      </div>
    </>
  );

  return (
    <div className="modal-overlay" onClick={onHide}>
      <div className="bank-steps-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{t('donate.bankSteps.howToTitle', { bank: selectedBank?.display })}</h3>
          <button className="close-btn" onClick={onHide}>
            ×
          </button>
        </div>
        <div className="modal-body">
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}
        </div>
      </div>
    </div>
  );
};

export default BankStepsModal;
